import React from "react";

import PropTypes from "prop-types";

export const HelperText = ({ children }: { children?: React.ReactNode }) =>
  children ? (
    <div className="text-primary-400 text-xs italic">{children}</div>
  ) : null;

export const ErrorText = ({
  inError,
  children,
}: {
  inError: boolean;
  children: React.ReactNode;
}) => (inError ? <p className="text-red-500">{children}</p> : null);

export const Label = ({
  children,
  htmlFor,
}: {
  children?: React.ReactNode;
  htmlFor?: string;
}) =>
  children ? (
    <label
      className="block text-neutral-600 text-xs font-bold "
      htmlFor={htmlFor}
    >
      {children}
    </label>
  ) : null;
